/**
 * List of all valid permission modules in the system
 */
export const VALID_MODULES = [
  'dashboard',
  'dashboard-pending-jobs',
  'dashboard-worker-data',
  'dashboard-statistics',
  'design-progress',
  
  'vendors',
  'vendors-import-export',
  'materials',
  'purchase-orders',
  'purchase_orders',
  'inventory',
  'designs',
  'workers',
  'design-cutting',
  'design_cutting',
  'assignments',
  'refinish-assignments',
  'refinish_assignments',
  'job-works',
  'job_works',
  'dupatta-tracker',
  // Finishing unit
  'production',
  'opening-entry',
  'press-station',
  'qc-station',
  'repair-queue',
  'design-cost',
  'payments',
  'dispatch',
  'expenses',
  'settings',
  'users',
  // Reports
  'report-production-summary',
  'report-worker-performance',
  'report-stitching-pending',
  'report-inventory-consumption',
  'report-job-work-ageing',
  'report-dispatch-delivery',
  'report-quality-control',
  'report-press-productivity',
  'report-po-fulfillment',
  'report-pending-barcoding',
];

/**
 * Module mapping for normalized module IDs
 * This helps with hyphenated module names that may come from backend as underscores
 */
export const MODULE_ALIASES: Record<string, string> = {
  'vendors_import_export': 'vendors-import-export',
  'vendors-import-export': 'vendors-import-export',
  'design_cutting': 'design-cutting',
  'design-cutting': 'design-cutting',
  'refinish_assignments': 'refinish-assignments',
  'refinish-assignments': 'refinish-assignments',
  'job_works': 'job-works',
  'job-works': 'job-works',
  // Purchase orders
  'purchase_orders': 'purchase-orders',
  'purchase-orders': 'purchase-orders',
  // Finishing unit aliases
  'production': 'production',
  'finishing': 'production',
  'finishing-unit': 'production',
  'finishing_unit': 'production',
  // New finishing unit sub-module aliases
  'opening_entry': 'opening-entry',
  'opening-entry': 'opening-entry',
  'qc_station': 'qc-station',
  'qc-station': 'qc-station',
  'press_station': 'press-station',
  'press-station': 'press-station',
  'repair_queue': 'repair-queue',
  'repair-queue': 'repair-queue'
  
};

/**
 * Module mapping with human-readable labels
 */
export const MODULE_LABELS = {
  'dashboard': 'Dashboard',
  'dashboard-pending-jobs': 'Dashboard - Pending Jobs',
  'dashboard-worker-data': 'Dashboard - Worker Data',
  'dashboard-statistics': 'Dashboard - Statistics',
  'design-progress': 'Design Progress',
  
  'vendors': 'Vendors',
  'vendors-import-export': 'Vendors - Import / Export',
  'materials': 'Purchase',
  'purchase-orders': 'Purchase Orders',
  'inventory': 'Inventory',
  'designs': 'Designs',
  'workers': 'Workers',
  'design-cutting': 'Design Cutting',
  'assignments': 'Work Assignments',
  'refinish-assignments': 'Refinish Assignments',
  'job-works': 'Job Works',
  'dupatta-tracker': 'Dupatta Tracker',
  // Finishing unit
  'production': 'Finishing Unit',
  'opening-entry': 'Opening Entry',
  'press-station': 'Press Station',
  'qc-station': 'QC Station',
  'repair-queue': 'Repair Queue',
  'design-cost': 'Design Cost Breakdown',
  'payments': 'Payments',
  'dispatch': 'Dispatch',
  'expenses': 'Expenses',
  'settings': 'Settings',
  'users': 'User Management',
  // Reports
  'report-production-summary': 'Report: Production Summary',
  'report-worker-performance': 'Report: Worker Performance',
  'report-stitching-pending': 'Report: Stitching Pending',
  'report-inventory-consumption': 'Report: Inventory Consumption',
  'report-job-work-ageing': 'Report: Job Work Ageing',
  'report-dispatch-delivery': 'Report: Dispatch & Delivery',
  'report-quality-control': 'Report: Quality Control',
  'report-press-productivity': 'Report: Press Productivity',
  'report-po-fulfillment': 'Report: Pending PO',
  'report-pending-barcoding': 'Report: Pending Barcoding',
};

/**
 * Module configuration with ID and label pairs for use in components
 * Filter out underscore versions to avoid duplicates in UI
 */
export const MODULES = VALID_MODULES
  .filter(moduleId => {
    // Keep only hyphenated versions or modules without underscores or hyphens
    if (moduleId.includes('_')) {
      // If this is an underscore version, check if we have a hyphen version
      const hyphenVersion = moduleId.replace(/_/g, '-');
      // Skip this module if we have a hyphen version
      return !VALID_MODULES.includes(hyphenVersion);
    }
    return true;
  })
  .map(moduleId => ({
    id: moduleId,
    label: MODULE_LABELS[moduleId as keyof typeof MODULE_LABELS] || moduleId
  })); 